import { createContext, useContext, useState, useEffect, useCallback } from "react";
import translations from "./translations";

const I18nContext = createContext(null);

export function I18nProvider({ children }) {
  const [lang, setLangState] = useState(() => localStorage.getItem("omni_lang") || "en");

  const setLang = useCallback((code) => {
    setLangState(code);
    localStorage.setItem("omni_lang", code);
  }, []);

  // t() function: get translated string, fallback to English, fallback to key
  const t = useCallback((key) => {
    return translations[lang]?.[key] || translations["en"]?.[key] || key;
  }, [lang]);

  return (
    <I18nContext.Provider value={{ lang, setLang, t }}>
      {children}
    </I18nContext.Provider>
  );
}

export const useI18n = () => useContext(I18nContext);
